/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FusionMelcoFusionModelsChannelListItem
 */
export interface FusionMelcoFusionModelsChannelListItem {
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoFusionModelsChannelListItem
     */
    channel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoFusionModelsChannelListItem
     */
    name?: string | null;
}

export function FusionMelcoFusionModelsChannelListItemFromJSON(json: any): FusionMelcoFusionModelsChannelListItem {
    return FusionMelcoFusionModelsChannelListItemFromJSONTyped(json, false);
}

export function FusionMelcoFusionModelsChannelListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoFusionModelsChannelListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'channel': !exists(json, 'channel') ? undefined : json['channel'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function FusionMelcoFusionModelsChannelListItemToJSON(value?: FusionMelcoFusionModelsChannelListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'channel': value.channel,
        'name': value.name,
    };
}


